import React from 'react';
import { Link } from 'react-router-dom';
import AwardMark from './AwardMark';
import { AWARD_NEWS_PATH, trackAwardClick } from './trackAward';
import type { AwardPlacement } from './trackAward';
import './award.css';

// 1) Homepage hero chip
export const AwardChip = () => (
	<Link
		className="award-chip award-focusable"
		to={AWARD_NEWS_PATH}
		onClick={() => trackAwardClick('home_hero')}>
		<AwardMark />
		<span className="award-chip__text">
			<span className="award-chip__title">Winner · 2026 Training Magazine Network Choice Awards</span>
			<span className="award-chip__meta">
				<span className="award-chip__cat--full">Immersive &amp; Spatial Learning Technologies</span>
				<span className="award-chip__cat--short">Immersive Learning</span> · <strong>Read the news →</strong>
			</span>
		</span>
	</Link>
);

// 2) Simsola 6D hero pill
export const AwardPill = () => (
	<Link
		className="award-pill award-focusable"
		to={AWARD_NEWS_PATH}
		onClick={() => trackAwardClick('6d_hero')}>
		<span className="award-pill__icon">
			<svg
				viewBox="0 0 24 24"
				fill="none"
				stroke="#0073DE"
				strokeWidth={1.75}
				strokeLinecap="round"
				strokeLinejoin="round"
				aria-hidden="true">
				<circle cx="12" cy="9" r="6" />
				<path d="M8.5 14.2 7 22l5-3 5 3-1.5-7.8" />
			</svg>
		</span>
		<span className="award-pill__label">
			<span className="award-pill__full">2026 Training Magazine Network Choice Award winner</span>
			<span className="award-pill__short">2026 TMN Choice Award winner</span>
		</span>
	</Link>
);

// 3) Simsola 6D "What makes Simsola unique?" card
export const AwardCard = ({ placement = '6d_unique_card' }: { placement?: AwardPlacement }) => (
	<aside className="award-card" aria-labelledby="award-card-title">
		<div className="award-card__head">
			<AwardMark size="lg" />
			<div>
				<div className="award-eyebrow">Award winner · 2026</div>
				<div className="award-card__org">Training Magazine Network Choice Awards</div>
			</div>
		</div>
		<h3 className="award-card__title" id="award-card-title">
			Chosen by the people who run L&amp;D programs.
		</h3>
		<p className="award-card__body">
			Simsola won in the Immersive &amp; Spatial Learning Technologies category of the 2026 Choice Awards — the only
			crowd-sourced awards in L&amp;D, voted on by customers, learners and practitioners in the Training Magazine
			Network.
		</p>
		<hr className="award-card__rule" />
		<Link
			className="award-link award-focusable"
			to={AWARD_NEWS_PATH}
			onClick={() => trackAwardClick(placement)}>
			Read the announcement →
		</Link>
	</aside>
);

// 4) About Us recognition band
export const RecognitionBand = () => (
	<div className="container">
		<section className="recognition" aria-labelledby="recognition-title">
			<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
				<div className="award-eyebrow">Recognition</div>
				<h2 className="recognition__title" id="recognition-title">
					Recognized for <span>immersive</span> learning.
				</h2>
			</div>
			<Link
				className="recognition__row award-focusable"
				to={AWARD_NEWS_PATH}
				onClick={() => trackAwardClick('about_recognition')}>
				<AwardMark size="lg" style={{ width: 72, height: 72 }} />
				<span className="recognition__year">2026</span>
				<span>
					<span className="recognition__name">Training Magazine Network Choice Awards</span>
					<span className="recognition__desc">
						Winner — Immersive &amp; Spatial Learning Technologies. Voted on by the L&amp;D community.
					</span>
				</span>
				<span className="award-link">Read the news →</span>
			</Link>
		</section>
	</div>
);

// 5) Global footer badge
export const FooterAward = () => (
	<Link
		className="footer-award award-focusable"
		to={AWARD_NEWS_PATH}
		onClick={() => trackAwardClick('footer')}>
		<AwardMark size="sm" />
		<span className="footer-award__text">
			<span className="footer-award__kicker">2026 Award winner</span>
			<span className="footer-award__name">Training Magazine Network Choice Awards</span>
		</span>
	</Link>
);
